'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = survey;
exports.loadSurvey = loadSurvey;
exports.loadLocations = loadLocations;
exports.loadProviders = loadProviders;
exports.loadSurveys = loadSurveys;
exports.saveFeedback = saveFeedback;
exports.loadAudienceInfo = loadAudienceInfo;
exports.createAudience = createAudience;
exports.loadLanguages = loadLanguages;
exports.setLanguage = setLanguage;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_SURVEY = 'binary/survey/LOAD_SURVEY';
var LOAD_SURVEY_SUCCESS = 'binary/survey/LOAD_SURVEY_SUCCESS';
var LOAD_SURVEY_FAIL = 'binary/survey/LOAD_SURVEY_FAIL';
var LOAD_LOCATIONS = 'binary/survey/LOAD_LOCATIONS';
var LOAD_LOCATIONS_SUCCESS = 'binary/survey/LOAD_LOCATIONS_SUCCESS';
var LOAD_LOCATIONS_FAIL = 'binary/survey/LOAD_LOCATIONS_FAIL';
var LOAD_PROVIDERS = 'binary/survey/LOAD_PROVIDERS';
var LOAD_PROVIDERS_SUCCESS = 'binary/survey/LOAD_PROVIDERS_SUCCESS';
var LOAD_PROVIDERS_FAIL = 'binary/survey/LOAD_PROVIDERS_FAIL';
var LOAD_SURVEYS = 'binary/survey/LOAD_SURVEYS';
var LOAD_SURVEYS_SUCCESS = 'binary/survey/LOAD_SURVEYS_SUCCESS';
var LOAD_SURVEYS_FAIL = 'binary/survey/LOAD_SURVEYS_FAIL';
var LOAD_LANGUAGES = 'binary/survey/LOAD_LANGUAGES';
var LOAD_LANGUAGES_SUCCESS = 'binary/survey/LOAD_LANGUAGES_SUCCESS';
var LOAD_LANGUAGES_FAIL = 'binary/survey/LOAD_LANGUAGES_FAIL';
var SET_LANGUAGE = 'binary/survey/SET_LANGUAGE';
var SAVE_SURVEY = 'binary/survey/SAVE_SURVEY';
var SAVE_SURVEY_SUCCESS = 'binary/survey/SAVE_SURVEY_SUCCESS';
var SAVE_SURVEY_FAIL = 'binary/survey/SAVE_SURVEY_FAIL';
var LOAD_AUDIENCE_INFO = 'binary/survey/LOAD_AUDIENCE_INFO';
var LOAD_AUDIENCE_INFO_SUCCESS = 'binary/survey/LOAD_AUDIENCE_INFO_SUCCESS';
var LOAD_AUDIENCE_INFO_FAIL = 'binary/survey/LOAD_AUDIENCE_INFO_FAIL';
var CREATE_AUDIENCE_INFO = 'binary/survey/CREATE_AUDIENCE_INFO';
var CREATE_AUDIENCE_INFO_SUCCESS = 'binary/survey/CREATE_AUDIENCE_INFO_SUCCESS';
var CREATE_AUDIENCE_INFO_FAIL = 'binary/survey/CREATE_AUDIENCE_INFO_FAIL';

var initialState = {
  loadedSurvey: false,
  loadingSurvey: false,
  data: false,
  loadedLocations: false,
  loadingLocations: false,
  locations: false,
  loadedProviders: false,
  loadingProviders: false,
  providers: false,
  loadedSurveys: false,
  loadingSurveys: false,
  surveys: false,
  loadedLanguages: false,
  loadingLanguages: false,
  languages: false,
  selectedLanguage: false,
  savingSurvey: false,
  savedSurvey: false,
  savedData: false,
  loadedAudienceInfo: false,
  loadingAudienceInfo: false,
  audienceInfo: false,
  createdAudienceInfo: false
};

function survey() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_SURVEY:
      return (0, _extends3.default)({}, state, {
        loadingSurvey: true
      });
    case LOAD_SURVEY_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingSurvey: false,
        loadedSurvey: true,
        data: action.result
      });
    case LOAD_SURVEY_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingSurvey: false,
        loadedSurvey: false,
        error: action.error
      });
    case LOAD_LOCATIONS:
      return (0, _extends3.default)({}, state, {
        loadingLocations: true
      });
    case LOAD_LOCATIONS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingLocations: false,
        loadedLocations: true,
        locations: action.result
      });
    case LOAD_LOCATIONS_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingLocations: false,
        loadedLocations: false,
        error: action.error
      });
    case LOAD_PROVIDERS:
      return (0, _extends3.default)({}, state, {
        loadingProviders: true
      });
    case LOAD_PROVIDERS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingProviders: false,
        loadedProviders: true,
        providers: [{ 'id': 913650, 'name': 'Clog_Brand', 'address': 'Clog_Brand,  Clog_BrandClog_Brand,  Clog_BrandClog_BrandClog_Brand' }, { 'id': 913651, 'name': 'Clog_BU', 'address': 'Clog_BU,  Clog_BUClog_BU,  Clog_BUClog_BUClog_BUClog_BU' }, { 'id': 913652, 'name': 'Clog_Region', 'address': 'Clog_Region,  Clog_RegionClog_Region,  Clog_RegionClog_RegionClog_Region' }, { 'id': 1057662, 'name': 'We Care Clinic child - Trivandrum', 'address': 'We Care Clinic child - Trivandrum,  We Care Clinic child - Trivandrum,  We Care Clinic child - Trivandrum' }]
      });
    case LOAD_PROVIDERS_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingProviders: false,
        loadedProviders: false,
        error: action.error
      });
    case LOAD_SURVEYS:
      return (0, _extends3.default)({}, state, {
        loadingSurveys: true
      });
    case LOAD_SURVEYS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingSurveys: false,
        loadedSurveys: true,
        list: action.result
      });
    case LOAD_SURVEYS_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingSurveys: false,
        loadedSurveys: false,
        error: action.error
      });
    case LOAD_LANGUAGES:
      return (0, _extends3.default)({}, state, {
        loadingLanguages: true
      });
    case LOAD_LANGUAGES_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingLanguages: false,
        loadedLanguages: true,
        languages: [{ 'id': 913650, 'name': 'Clog_Brand', 'flag': 'Clog_Brand,  Clog_BrandClog_Brand,  Clog_BrandClog_BrandClog_Brand' }, { 'id': 913651, 'name': 'Clog_BU', 'flag': 'Clog_BU,  Clog_BUClog_BU,  Clog_BUClog_BUClog_BUClog_BU' }, { 'id': 913652, 'name': 'Clog_Region', 'flag': 'Clog_Region,  Clog_RegionClog_Region,  Clog_RegionClog_RegionClog_Region' }, { 'id': 1057662, 'name': 'We Care Clinic child - Trivandrum', 'flag': 'We Care Clinic child - Trivandrum,  We Care Clinic child - Trivandrum,  We Care Clinic child - Trivandrum' }]
      });
    case LOAD_LANGUAGES_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingLanguages: false,
        loadedLanguages: false,
        error: action.error
      });
    case SET_LANGUAGE:
      return (0, _extends3.default)({}, state, {
        selectedLanguage: action.result
      });
    case SAVE_SURVEY:
      return (0, _extends3.default)({}, state, {
        savingSurvey: true
      });
    case SAVE_SURVEY_SUCCESS:
      return (0, _extends3.default)({}, state, {
        savingSurvey: false,
        savedSurvey: true,
        savedData: action.result
      });
    case SAVE_SURVEY_FAIL:
      return (0, _extends3.default)({}, state, {
        savingSurvey: false,
        savedSurvey: false,
        error: action.error
      });
    case LOAD_AUDIENCE_INFO:
      return (0, _extends3.default)({}, state, {
        loadingAudienceInfo: true
      });
    case LOAD_AUDIENCE_INFO_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingAudienceInfo: false,
        loadedAudienceInfo: true,
        audienceInfo: action.result
      });
    case LOAD_AUDIENCE_INFO_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingAudienceInfo: false,
        loadedAudienceInfo: false,
        error: action.error
      });
    case CREATE_AUDIENCE_INFO:
      return (0, _extends3.default)({}, state);
    case CREATE_AUDIENCE_INFO_SUCCESS:
      return (0, _extends3.default)({}, state, {
        createdAudienceInfo: action.result
      });
    case CREATE_AUDIENCE_INFO_FAIL:
      return (0, _extends3.default)({}, state, {
        error: action.error
      });
    default:
      return state;
  }
}

function loadSurvey(clientId, surveyId, locationId, audienceCode) {
  return {
    types: [LOAD_SURVEY, LOAD_SURVEY_SUCCESS, LOAD_SURVEY_FAIL],
    promise: function promise(client) {
      return client.get('/feedback/' + clientId + '/survey/' + surveyId, {
        params: {
          locationId: locationId,
          audienceCode: audienceCode
        }
      });
    }
  };
}

function loadLocations(clientId, sourceId) {
  //   return {type: LOAD_LOCATIONS_SUCCESS, result: [clientId, sourceId]};
  return {
    types: [LOAD_LOCATIONS, LOAD_LOCATIONS_SUCCESS, LOAD_LOCATIONS_FAIL],
    promise: function promise(client) {
      return client.get('/feedback/' + clientId + '/locations?sourceId=' + sourceId, {
        params: {}
      });
    }
  };
}

function loadProviders() {
  return { type: LOAD_PROVIDERS_SUCCESS, result: [] };
}

function loadSurveys(clientId, locationId) {
  //   return {type: LOAD_SURVEYS_SUCCESS, result: [clientId, locationId]};
  return {
    types: [LOAD_SURVEYS, LOAD_SURVEYS_SUCCESS, LOAD_SURVEYS_FAIL],
    promise: function promise(client) {
      return client.get('/feedback/' + clientId + '/surveys?locationId=' + locationId, {
        params: {}
      });
    }
  };
}

function saveFeedback(clientId, data) {
  return {
    types: [SAVE_SURVEY, SAVE_SURVEY_SUCCESS, SAVE_SURVEY_FAIL],
    promise: function promise(client) {
      return client.post('/feedback/' + clientId + '/submit', {
        data: data
      });
    }
  };
}

function loadAudienceInfo(clientId, audienceCode, trackClick) {
  return {
    types: [LOAD_AUDIENCE_INFO, LOAD_AUDIENCE_INFO_SUCCESS, LOAD_AUDIENCE_INFO_FAIL],
    promise: function promise(client) {
      return client.get('/feedback/' + clientId + '/audience/' + audienceCode, {
        params: {
          trackClick: trackClick
        }
      });
    }
  };
}

function createAudience(clientId, data) {
  return {
    types: [CREATE_AUDIENCE_INFO, CREATE_AUDIENCE_INFO_SUCCESS, CREATE_AUDIENCE_INFO_FAIL],
    promise: function promise(client) {
      return client.post('/feedback/' + clientId + '/testimonialsurvey/campaignAudience', {
        data: data
      });
    }
  };
}

function loadLanguages() {
  return { type: LOAD_LANGUAGES_SUCCESS, result: [] };
}

function setLanguage(lang) {
  return { type: SET_LANGUAGE, result: lang };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/survey.js
// module id = 179
// module chunks = 0